var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardDateCreatedAt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27272 0.666673H6.54544V0H5.8182V1.66668H5.09092V0.666673H2.90908V0H2.1818V1.66668H1.45456V0.666673H0.727279C0.325612 0.666673 0 0.965151 0 1.33335V6.33336C0 6.70152 0.325612 7 0.727279 7H7.27272C7.67439 7 8 6.70152 8 6.33336V1.33335C8 0.965151 7.67439 0.666673 7.27272 0.666673ZM2.54544 6.00002H1.09092V4.66668H2.54544V6.00002ZM2.54544 4H1.09092V2.66669H2.54544V4ZM4.72728 6.00002H3.27272V4.66668H4.72728V6.00002ZM4.72728 4H3.27272V2.66669H4.72728V4ZM6.90908 4H5.45456V2.66669H6.90908V4Z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDateCreatedAt);
export default __webpack_public_path__ + "static/media/card-date-created-at.fb886a763efb5a48b0e6783775a3eca3.svg";
export { ForwardRef as ReactComponent };